// removed by extract-text-webpack-plugin
module.exports = {"counterContainer":"_1_iLLlWOQTStqNtbrpvC24","counterContainerVisibility":"_2nJausKOcLUPBHrfvT_5JV","counter":"_2D0fJYGAQz16oi4Ql4GR-P"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/counter.css
// module id = 749
// module chunks = 0